import hosViewTpl from './views/hosView.html';
import './profileSetting.scss';
import hosViewCtrl from './controllers/hosViewController';


const name = 'hosView';
var module = angular.module("app.hosView", [

]).component(name, {
    template: hosViewTpl,
    controllerAs: name,
    controller: hosViewCtrl
}).controller('hosViewCtrl', hosViewCtrl);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('hosView', {
            parent: 'app',
            url: '/hosView',
            views: {
                '@': {
                    template: hosViewTpl,
                    controller: hosViewCtrl,
                    controllerAs: 'hosView'
                }
            }
        })
}); */


// WEBPACK FOOTER //
// ./src/app/profileSetting/hosViewModule.js